import { Mongo } from "meteor/mongo";
import SimpleSchema from "simpl-schema";

export const ContactsCollection = new Mongo.Collection("contacts");

export const ContactSchema = new SimpleSchema({
    fullName: String,
    phoneNumber: { type: String, optional: true },
    emailAddress: String,
    message: String,
    interestedVehicle: { type: String, optional: true },
    status: String,
    statusUpdatedAt: Date,
    assignedTo: { type: String, optional: true },
    notes: { type: Array, optional: true },
    "notes.$": { type: Object, blackbox: true },
    createdAt: Date,
    updatedAt: Date,
});

export function normalizeContactDoc(doc) {
    return {
        fullName: doc.fullName?.trim() || "",
        phoneNumber: doc.phoneNumber?.trim() || "",
        emailAddress: doc.emailAddress?.trim() || "",
        message: doc.message?.trim() || "",
        interestedVehicle: doc.interestedVehicle?.trim() || "",
    };
}
